/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElInput as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElRadioGroup as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { ElFormItem as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSelect as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElDivider as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/divider/style/css';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d03ec70"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "flex items-center"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "单次限额", -1));
const _hoisted_4 = {
  class: "flex items-center marginT10"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "单周限额", -1));
const _hoisted_6 = {
  class: "flex items-center marginT10"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "单月限额", -1));
const _hoisted_8 = {
  class: "flex items-center"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "单次限额", -1));
const _hoisted_10 = {
  class: "flex items-center marginT10"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "单周限额", -1));
const _hoisted_12 = {
  class: "flex items-center marginT10"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "单月限额", -1));
const _hoisted_14 = {
  class: "dialog-footer"
};
import TimeRangePicker from '@ultra/share/components/TimeRangePicker/index.vue';
import { apiUsdkUpdateRealNameProduct } from '@/api/usdk';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'addOrEditChannelRealName',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const dialogVisible = ref(false);
    const formRef = ref();
    const type = ref('');
    const confirmLoading = ref(false);
    const login = ref([{
      label: '不实名',
      value: 0
    }, {
      label: '可选实名',
      value: 1
    }, {
      label: '强制实名',
      value: 2
    }]);
    const gameInfo = ref();
    const selectedRowKeys = ref([]);
    const emits = __emit;
    const form = ref({
      cid: undefined,
      projectId: undefined,
      login: 2,
      pay: 2,
      needPhone: false,
      isRealIcValidate: true,
      isAdultLoginNeed: true,
      minorsLogin: true,
      minorsLoginOpt: 0,
      minorsWdot: 0,
      minorsHdot: 60,
      minorsRelogin: false,
      minorsReloginInterval: '',
      isAdultPayNeed: true,
      minorsPay: true,
      minorsAge1: 8,
      minorsAge2: 16,
      minorsAge3: 18,
      minorsAge2Opa: 50,
      minorsAge2Wpa: 200,
      minorsAge2Mpa: 200,
      minorsAge3Opa: 100,
      minorsAge3Wpa: 400,
      minorsAge3Mpa: 400,
      minorsTipEnable: false,
      minorsLoginTipEnable: false,
      minorsPayTipEnable: false,
      minorsExpireTipEnable: false,
      isEnableTryFloating: false,
      isEnableCloseFloating: false,
      startTime: '00:00:00',
      endTime: '23:59:59'
    });
    const handleClose = formEl => {
      dialogVisible.value = false;
      if (!formEl) {
        return;
      }
      formEl.resetFields();
    };
    const changeLogin = val => {
      if (val === 2) {
        form.value.pay = 2;
      }
    };
    const show = payload => {
      dialogVisible.value = true;
      gameInfo.value = payload.gameInfo;
      type.value = payload.type;
      payload.multipleSelection && payload.multipleSelection.map(item => {
        selectedRowKeys.value.push(item.usdkCid);
      });
      if (payload.data) {
        form.value = payload.data;
      }
    };
    const handleOk = formEl => {
      if (!formEl) {
        return;
      }
      formEl.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(form.value));
          params.gid = gameInfo.value.Id;
          if (form.value.startTime && form.value.endTime) {
            params.minorsLoginStart = form.value.startTime.substr(0, 5) || '';
            params.minorsLoginEnd = form.value.endTime.substr(0, 5) || '';
          }
          delete params.updateTime;
          delete params.createTime;
          delete params.startTime;
          delete params.endTime;
          for (let k in params) {
            if (params[k] === null || params[k] === '') {
              delete params[k];
            }
          }
          if (type.value === 'batchEdit') {
            params.cids = selectedRowKeys.value.join(',');
          } else {
            params.cids = params.usdkCid;
          }
          if (Array.isArray(params.projectId) && params.projectId.length) {
            params.projectId = params.projectId.join(',');
          }
          confirmLoading.value = true;
          apiUsdkUpdateRealNameProduct(params).then(res => {
            confirmLoading.value = false;
            if (res.code === 0) {
              emits('success');
              handleClose(formRef.value);
            }
          });
        }
      });
    };
    const chargeValidator = (rule, value, callback) => {
      if (!form.value.minorsAge2Opa) {
        callback(new Error('请输入单次限额'));
      } else if (!form.value.minorsAge2Wpa) {
        callback(new Error('请输入单周限额'));
      } else if (!form.value.minorsAge2Mpa) {
        callback(new Error('单月限额'));
      } else {
        callback();
      }
    };
    const chargeValidator1 = (rule, value, callback) => {
      if (!form.value.minorsAge3Opa) {
        callback(new Error('请输入单次限额'));
      } else if (!form.value.minorsAge3Wpa) {
        callback(new Error('请输入单周限额'));
      } else if (!form.value.minorsAge3Mpa) {
        callback(new Error('单月限额'));
      } else {
        callback();
      }
    };
    const timeValid1 = (rule, value, callback) => {
      console.log(form.value.minorsWdot, 'form.value.minorsWdot');
      if (form.value.minorsHdot === undefined || form.value.minorsHdot === null) {
        callback(new Error('请填写未成年工作日累计在线时长（分钟）'));
      } else if (form.value.minorsWdot) {
        if (form.value.minorsWdot < 10 && form.value.minorsWdot > 0) {
          callback(new Error('工作日累计在线时长（分钟）不能小于10分钟'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const timeValid2 = (rule, value, callback) => {
      if (form.value.minorsHdot === undefined || form.value.minorsHdot === null) {
        callback(new Error('请填写未成年节假日累计在线时长（分钟）'));
      } else if (form.value.minorsHdot) {
        if (form.value.minorsHdot < 10 && form.value.minorsHdot > 0) {
          callback(new Error('节假日累计在线时长（分钟）不能小于10分钟'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const timeRangeValidator = (rule, value, callback) => {
      const baseDate = '2022-01-01 ';
      const start = dayjs(`${baseDate}${form.value.minorsLoginStart}`).unix();
      const end = dayjs(`${baseDate}${form.value.minorsLoginEnd}`).unix();
      if (!form.value.minorsLoginStart || !form.value.minorsLoginEnd) {
        callback(new Error('请选择未成年登录时间段'));
      } else if (form.value.minorsLoginStart && form.value.minorsLoginEnd) {
        const res = end - start;
        const ten = 10 * 60;
        if (res < ten) {
          callback(new Error('未成年登录时间段不能小于10分钟'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_divider = __unplugin_components_0;
      const _component_el_option = __unplugin_components_1;
      const _component_el_select = __unplugin_components_2;
      const _component_el_form_item = __unplugin_components_3;
      const _component_el_radio = __unplugin_components_4;
      const _component_el_radio_group = __unplugin_components_5;
      const _component_el_input = __unplugin_components_6;
      const _component_el_form = __unplugin_components_7;
      const _component_el_button = __unplugin_components_8;
      const _component_el_dialog = __unplugin_components_9;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        "before-close": () => handleClose(_unref(formRef)),
        title: `${_unref(type) === 'batchEdit' ? '批量编辑' : '编辑'}渠道参数`,
        width: "50%"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_14, [_createVNode(_component_el_button, {
          onClick: _cache[21] || (_cache[21] = $event => handleClose(_unref(formRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: _unref(confirmLoading),
          type: "primary",
          onClick: _cache[22] || (_cache[22] = $event => handleOk(_unref(formRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: _unref(form),
          "label-width": "200px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_divider, {
            "content-position": "left"
          }, {
            default: _withCtx(() => [_createTextVNode("实名管理")]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              message: '请选择登录实名控制',
              trigger: 'change'
            },
            label: "登录实名控制",
            prop: "login"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(form).login,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).login = $event),
              placeholder: "请选择登录实名控制",
              size: "large",
              onChange: changeLogin
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(login), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              message: '请选择支付实名控制',
              trigger: 'change'
            },
            label: "支付实名控制",
            prop: "pay"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(form).pay,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).pay = $event),
              disabled: _unref(form).login === 2,
              placeholder: "请选择支付实名控制",
              size: "large"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(login), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              message: '请选择是否收集手机号',
              trigger: 'change'
            },
            label: "是否收集手机号",
            prop: "needPhone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).needPhone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).needPhone = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: true
              }, {
                default: _withCtx(() => [_createTextVNode("是")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: false
              }, {
                default: _withCtx(() => [_createTextVNode("否")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              message: '请选择是否需要实名验证',
              trigger: 'change'
            },
            label: "实名验证",
            prop: "isRealIcValidate"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).isRealIcValidate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).isRealIcValidate = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: true
              }, {
                default: _withCtx(() => [_createTextVNode("真实验证")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: false
              }, {
                default: _withCtx(() => [_createTextVNode("非真实验证")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_divider, {
            "content-position": "left"
          }, {
            default: _withCtx(() => [_createTextVNode("登陆防沉迷管理")]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              message: '请选择是否需要登录未成年判断',
              trigger: 'change'
            },
            label: "登录未成年判断",
            prop: "isAdultLoginNeed"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).isAdultLoginNeed,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).isAdultLoginNeed = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: true
              }, {
                default: _withCtx(() => [_createTextVNode("已判断")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: false
              }, {
                default: _withCtx(() => [_createTextVNode("未判断")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _unref(form).isAdultLoginNeed ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_form_item, {
            label: "未成年登陆",
            prop: "minorsLogin"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).minorsLogin,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).minorsLogin = $event),
              rules: {
                required: true,
                message: '请选择未成年是否允许登录',
                trigger: 'change'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: true
              }, {
                default: _withCtx(() => [_createTextVNode("允许")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: false
              }, {
                default: _withCtx(() => [_createTextVNode("不允许")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _unref(form).minorsLogin ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            rules: {
              required: true,
              message: '请选择限制部分年龄登录',
              trigger: 'change'
            },
            label: "限制部分年龄登录",
            prop: "minorsLoginOpt"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).minorsLoginOpt,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).minorsLoginOpt = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 0
              }, {
                default: _withCtx(() => [_createTextVNode("不限制")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("8岁以下")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_createTextVNode("12岁以下")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 3
              }, {
                default: _withCtx(() => [_createTextVNode("16岁以下")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              validator: timeRangeValidator,
              trigger: 'change'
            },
            label: "未成年登录时间段",
            prop: "minorsLoginStart"
          }, {
            default: _withCtx(() => [_createVNode(TimeRangePicker, {
              endValue: _unref(form).minorsLoginEnd,
              "onUpdate:endValue": _cache[7] || (_cache[7] = $event => _unref(form).minorsLoginEnd = $event),
              startValue: _unref(form).minorsLoginStart,
              "onUpdate:startValue": _cache[8] || (_cache[8] = $event => _unref(form).minorsLoginStart = $event),
              "value-format": "HH:mm"
            }, null, 8, ["endValue", "startValue"])]),
            _: 1
          }, 8, ["rules"]), _unref(form).minorsLogin ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_form_item, {
            rules: {
              required: true,
              validator: timeValid1,
              trigger: 'change'
            },
            label: "未成年工作日累计在线时长（分钟）",
            prop: "minorsWdot"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).minorsWdot,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).minorsWdot = $event),
              min: 0,
              class: "width300px",
              p: "",
              placeholder: "请输入未成年工作日累计在线时长",
              type: "number"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              validator: timeValid2,
              trigger: 'change'
            },
            label: "未成年节假日累计在线时长（分钟）",
            prop: "minorsHdot"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).minorsHdot,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(form).minorsHdot = $event),
              min: 0,
              class: "width300px",
              placeholder: "请输入未成年节假日累计在线时长",
              type: "number"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"]), false ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "未成年提示弹窗"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).minorsTipEnable,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(form).minorsTipEnable = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: true
              }, {
                default: _withCtx(() => [_createTextVNode("提示")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: false
              }, {
                default: _withCtx(() => [_createTextVNode("不提示")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _createVNode(_component_el_divider, {
            "content-position": "left"
          }, {
            default: _withCtx(() => [_createTextVNode("支付防沉迷管理")]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "支付未成年判断"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).isAdultPayNeed,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(form).isAdultPayNeed = $event),
              rules: {
                required: true,
                message: '请选择支付未成年判断',
                trigger: 'change'
              },
              prop: "isAdultPayNeed"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: true
              }, {
                default: _withCtx(() => [_createTextVNode("已判断")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: false
              }, {
                default: _withCtx(() => [_createTextVNode("未判断")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _unref(form).isAdultPayNeed ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_form_item, {
            rules: {
              required: true,
              message: '请选择未成年允许充值',
              trigger: 'change'
            },
            label: "未成年允许充值",
            prop: "minorsPay"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).minorsPay,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(form).minorsPay = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: true
              }, {
                default: _withCtx(() => [_createTextVNode("允许")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: false
              }, {
                default: _withCtx(() => [_createTextVNode("不允许")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _unref(form).minorsPay ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_form_item, {
            label: "禁止充值年龄段"
          }, {
            default: _withCtx(() => [_createTextVNode(" 0-8岁 ")]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              validator: chargeValidator,
              trigger: 'change'
            },
            label: "8-16岁充值限制",
            prop: "minorsAge2Opa"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_input, {
              modelValue: _unref(form).minorsAge2Opa,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(form).minorsAge2Opa = $event),
              class: "width300px marginL10",
              placeholder: "请输入单次限额"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_input, {
              modelValue: _unref(form).minorsAge2Wpa,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(form).minorsAge2Wpa = $event),
              class: "width300px marginL10",
              placeholder: "请输入单周限额"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_input, {
              modelValue: _unref(form).minorsAge2Mpa,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(form).minorsAge2Mpa = $event),
              class: "width300px marginL10",
              placeholder: "请输入单月限额"
            }, null, 8, ["modelValue"])])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            rules: {
              required: true,
              validator: chargeValidator1,
              trigger: 'change'
            },
            label: "16-18岁充值限制",
            prop: "minorsAge3Opa"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_input, {
              modelValue: _unref(form).minorsAge3Opa,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(form).minorsAge3Opa = $event),
              class: "width300px marginL10",
              placeholder: "请输入单次限额"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_input, {
              modelValue: _unref(form).minorsAge3Wpa,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => _unref(form).minorsAge3Wpa = $event),
              class: "width300px marginL10",
              placeholder: "请输入单周限额"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_el_input, {
              modelValue: _unref(form).minorsAge3Mpa,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(form).minorsAge3Mpa = $event),
              class: "width300px marginL10",
              placeholder: "请输入单月限额"
            }, null, 8, ["modelValue"])])]),
            _: 1
          }, 8, ["rules"])], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _unref(form).minorsPay ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "支付限额弹窗"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).minorsPayTipEnable,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _unref(form).minorsPayTipEnable = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: true
              }, {
                default: _withCtx(() => [_createTextVNode("提示")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: false
              }, {
                default: _withCtx(() => [_createTextVNode("不提示")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["modelValue", "before-close", "title"]);
    };
  }
});